<template>
  <div class="modal fade confirm scProductPopup" :class="{ 'is-open': open }">
    <!------------------------ 步驟一start ---------------------------->
    <div class="modal-dialog" v-if="!addOtherInsuredPopup">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">選擇附約</h3>
        </div>
        <div class="modal-body px_25">
          <!-- -------------------主要區塊start ----------------------->
          <h5 class="mf-textWrap">
            {{
              `${mainProduct.prod_name}(${mainProduct.prod_id})${selectedRisk(
                mainProduct
              )}`
            }}<span v-if="mainProduct.prod_type == '1'"
              >{{
                `(${
                  mainProduct.FEATURE_DATA.pay_period_matur == "1"
                    ? "歲滿期"
                    : "繳費年期"
                }:${mainProduct.pay_prd}${
                  mainProduct.FEATURE_DATA.pay_period_matur == "1" ? "歲" : "年"
                }/保額:${formatMethods(mainProduct.amt)}`
              }}
              <span
                >{{
                  unit_curr(
                    mainProduct.FEATURE_DATA.amt_unit,
                    mainProduct.FEATURE_DATA.curr
                  )
                }})
              </span> </span
            >{{ `可搭配以下附約:` }}
          </h5>
          <p class="scProductPopup__notice">
            請注意!
            同一被保險人僅可購買一件實支實付醫療保險商品(含同業)及一件實支實付傷害保險商品
            <br />
            <br />
            根據要/被保人資訊自動剔除無法承保的商品【目前篩選條件：要保人-{{
              insurer_gender == "1" ? "男" : "女"
            }}/{{ insurer_age }}歲、被保人-{{
              insured_gender == "1" ? "男" : "女"
            }}/{{ insured_age }}歲】
          </p>
          <!-- 附約列表 -->
          <div
            class="mfTable__table sc__table mt_5 pb_10"
            v-if="scProductListScope.length && !loading"
          >
            <div class="mfTable__table__head">
              <div>選取</div>
              <div>商品名稱</div>
              <div>被保險人</div>
              <div>承保身分</div>
              <div></div>
            </div>
            <div class="mfTable__table__body">
              <div
                class="mfTable__table__body--row"
                v-for="(item, index) in filteredScList"
                :key="`${mainProduct.uniqueKey}__checkbox__${index}`"
              >
                <div>
                  <div class="checkbox checkbox-inline">
                    <input
                      type="checkbox"
                      :id="`${mainProduct.uniqueKey}__checkbox__${index}`"
                      @change="checkHandler($event, item)"
                      :checked="item.is_checked == '1'"
                      :disabled="item.rmk != ''"
                    />
                    <label
                      :for="`${mainProduct.uniqueKey}__checkbox__${index}`"
                    ></label>
                  </div>
                </div>
                <div class="text-left mf-textWrap">
                  {{ item.prod_name }}
                  <span class="text-nowrap">({{ item.prod_id }})</span>
                </div>
                <div>{{ truncate(item.insured_name, 12) }}</div>
                <div class="position-relative">
                  <select
                    v-if="
                      item.sc_relationship != '1' && item.sc_relationship != '4'
                    "
                    class="form-control"
                    style="width: 7rem"
                    :id="`${mainProduct.uniqueKey}__relationship__${index}`"
                    :data-vv-name="`${mainProduct.uniqueKey}__relationship__${index}`"
                    :class="{
                      'is-invalid': errors.has(
                        `${mainProduct.uniqueKey}__relationship__${index}`
                      ),
                    }"
                    v-validate.continues="
                      item.rmk || item.is_checked != '1'
                        ? ''
                        : `checkRelationship_${item.prod_id}${item.insured_name}|onlyMate_${item.prod_id}${item.insured_name}`
                    "
                    data-vv-as="請選擇承保身分"
                    v-model="item.relationship"
                    :disabled="item.rmk != '' || item.is_checked != '1'"
                  >
                    <option value="" disabled>請選擇</option>
                    <option
                      value="2"
                      v-if="item.sc_relationship.indexOf('2') > -1"
                    >
                      配偶
                    </option>
                    <option
                      value="3"
                      v-if="item.sc_relationship.indexOf('3') > -1"
                    >
                      子女
                    </option>
                  </select>
                  <div class="text-red text-left" style="font-size: 13px">
                    {{
                      errors.first(
                        `${mainProduct.uniqueKey}__relationship__${index}`
                      )
                    }}
                  </div>
                </div>
                <div class="text-left mf-textWrap px_4">
                  <span style="white-space: pre-wrap">{{ item.rmk }}</span>
                </div>
              </div>
            </div>
            <div
              v-if="scProductListScope.every((item) => item.rmk != '')"
              style="text-align: center"
            >
              <p>沒有資料可供選擇 !</p>
            </div>
            <!-- 其他被保人按鈕 -->
            <div>
              <div
                class="btn btn-default mt_10"
                @click="addOtherInsuredPopup = true"
                v-if="addOtherButtonShow"
              >
                新增其他被保人
              </div>
            </div>
            <!-- 確定取消按鈕 -->
            <div class="action text-right px_12 mt_10">
              <button
                type="submit"
                class="btn btn-default btn-sm py_5"
                @click.stop="$emit('close')"
              >
                取消
              </button>
              <button
                type="submit"
                class="btn btn-primary btn-sm py_5 ml_10"
                @click.stop="toImport()"
                :disabled="!is_selected_sc"
              >
                確定
              </button>
            </div>
          </div>
          <div v-if="loading" class="mt_20">
            <h2 class="text-center">載入中...</h2>
          </div>
          <!-- -------------------主要區塊end ----------------------->
        </div>
      </div>
    </div>
    <!------------------------ 步驟一end ---------------------------->
    <!------------------------ 新增其他被保人 start ---------------------------->
    <div class="modal-dialog" v-if="addOtherInsuredPopup">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">新增其他被保人</h3>
        </div>
        <div class="modal-body">
          <!-- -------------------新增其他被保人 主要區塊start ----------------------->
          <div class="addOther">
            <div
              class="addOther__item mb_5"
              v-for="(item, index) in addOtherCeater"
              :key="index"
            >
              <div class="addOther__item__index">{{ index + 1 }}</div>
              <div class="addOther__item__form">
                <!-- 姓名 -->
                <div class="addOther__row mr_9">
                  <span>姓名:</span>
                  <div class="position-relative">
                    <input
                      type="text"
                      :data-vv-name="`addOther__name__${index}`"
                      data-vv-as="姓名"
                      v-model.trim="item.insured_name"
                      class="form-control form-control-inline"
                      :class="{
                        'is-invalid': errors.has(`addOther__name__${index}`),
                      }"
                      style="width: 148px"
                      v-validate="'required|checkNm'"
                      :disabled="item.isAdded"
                      alt="ch"
                    />
                    <div
                      class="clearPosition pl_10 pt_10"
                      @click="clear(item, 'insured_name')"
                      v-if="errors.has(`addOther__name__${index}`)"
                    ></div>
                    <span class="waring-text">
                      {{ errors.first(`addOther__name__${index}`) }}
                    </span>
                  </div>
                </div>
                <!-- 性別 -->
                <div class="addOther__row mt_15">
                  <span>性別:</span>
                  <div class="position-relative d-flex">
                    <div
                      class="radio radio-inline mr_7"
                      :class="{ disabled: item.isAdded }"
                    >
                      <input
                        type="radio"
                        :name="`addOther__sex__${index}`"
                        value="1"
                        :id="`addOther__sex__${index}-man`"
                        v-model="item.insured_gender"
                        v-validate="'required'"
                        :data-vv-name="`addOther__sex__${index}`"
                        data-vv-as="性別"
                        :disabled="item.isAdded"
                      />
                      <label :for="`addOther__sex__${index}-man`">男</label>
                    </div>
                    <div
                      class="radio radio-inline"
                      :class="{ disabled: item.isAdded }"
                    >
                      <input
                        type="radio"
                        :name="`addOther__sex__${index}`"
                        value="2"
                        :id="`addOther__sex__${index}-feman`"
                        v-model="item.insured_gender"
                        v-validate="'required'"
                        :data-vv-name="`addOther__sex__${index}`"
                        data-vv-as="性別"
                        :disabled="item.isAdded"
                      />
                      <label :for="`addOther__sex__${index}-feman`">女</label>
                    </div>
                    <span class="waring-text">
                      {{ errors.first(`addOther__sex__${index}`) }}
                    </span>
                  </div>
                  <!-- 生日 -->
                  <span>生日:</span>
                  <div class="position-relative mr_5">
                    <MfDatePicker
                      :format="dateFormatter"
                      :language="dateLang"
                      :first-day-of-week="1"
                      :typeable="true"
                      @clearAll="clearBirthday(item, index)"
                      @input="
                        birthdayChecker($event, item, `addOther__age__${index}`)
                      "
                      :value="
                        birthdayFormatForDatePick(
                          item.insured_birthday,
                          `${index}_dataPicker`
                        )
                      "
                      :disabled="item.isAdded"
                      :class="{
                        'is-invalid':
                          item.birthdayError ||
                          errors.has(`addOther__age__${index}`),
                      }"
                      v-validate="{ required: !item.insured_age }"
                      :data-vv-name="`addOther__age__${index}`"
                      data-vv-as="生日或年齡"
                      :ref="`${index}_dataPicker`"
                      placeholder="YY/MM/DD"
                    />
                    <div
                      class="clearBirthday text-green"
                      v-show="item.insured_birthday"
                      @click.stop="clearBirthday(item, index)"
                      v-if="!item.isAdded"
                    >
                      清除
                    </div>
                    <span class="waring-text">
                      {{ errors.first(`addOther__age__${index}`) }}
                    </span>
                  </div>
                  <!-- 年齡 -->
                  <div class="addOther__row">
                    <span>或年齡:</span>
                    <input
                      type="text"
                      v-model.trim="item.insured_age"
                      @input="ageHandler(item)"
                      class="form-control form-control-inline"
                      style="width: 70px"
                      :class="{
                        'is-invalid': errors.has(`addOther__age__${index}`),
                      }"
                      maxlength="3"
                      v-validate="{ required: !item.insured_birthday }"
                      :data-vv-name="`addOther__age__${index}`"
                      data-vv-as="生日或年齡"
                      :disabled="item.insured_birthday != '' || item.isAdded"
                    />
                  </div>
                </div>
              </div>
              <div
                class="addOther__item__delete btn btn-default btn-sm px_2 pt_2"
                @click="deleteOne(index)"
                v-if="index != 0 || !item.isAdded"
              >
                <img src="@/desktop/views/mf/assets/trash.svg" alt="" />
              </div>
            </div>
          </div>
          <div class="addOther__button" @click="addOne()">
            <div class="addOther__button__icon mr_10">+</div>
            再增加一筆
          </div>
          <!-- 確定取消按鈕 -->
          <div class="action text-right px_12 mt_10">
            <button
              type="submit"
              class="btn btn-default btn-sm py_5"
              @click.stop="addOtherInsuredPopup = false"
              :disabled="loading"
            >
              取消
            </button>
            <button
              type="submit"
              class="btn btn-primary btn-sm py_5 ml_10"
              @click.stop="addOthersHandler()"
              :disabled="loading"
            >
              {{ loading ? "新增中..." : "新增" }}
            </button>
          </div>
          <!-- -------------------新增其他被保人 主要區塊end ----------------------->
        </div>
      </div>
    </div>
    <!------------------------ 新增其他被保人 end ---------------------------->
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import Vue from "vue";
// import { body as mcokScProductList } from "@/desktop/views/mf/mock/sc_prod_list.json";
import Avatar from "@/desktop/components/Avatar";
// import DatePicker from "@/components/DatePicker/components/Datepicker";
import MfDatePicker from "@/desktop/views/mf/plugin/DatePicker/components/Datepicker.vue";

import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import mf_Mixin from "@/desktop/views/mf/mixin";
Validator.extend("checkNm", {
  getMessage: "姓名不能有特殊符號",
  validate: (value) => {
    let pattern = /[<>!@#$^&,."'?%*()+/{}[\]\\|~`=\s]/g;
    let isNonEmpty = value.trim().length > 0;
    let isFormatCurrect = value.match(pattern) == null;
    return isNonEmpty && isFormatCurrect;
  },
});

export default {
  name: "scProductPopup",
  mixins: [mf_Mixin],
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    mainProduct: {
      type: Object,
      default: () => {},
    },
    uniqueKey: {
      type: String,
    },
  },
  components: { Avatar, MfDatePicker },

  data() {
    return {
      scProductListScope: [],
      //新增其他被保人模式是否開啟
      addOtherInsuredPopup: false,
      addOtherCeater: [
        {
          insured_id: "",
          insured_name: "",
          insured_gender: "",
          insured_birthday: "",
          insured_age: "",
        },
      ],
      other_people_list: [], //不包含other_insured_list的列表
      //其他被保人清單，已經被按下確定要新增的
      other_insured_list: [],
      loading: false,
      needCheckRequire: false, //是否檢核必填(必填只在按確定的時候檢核)
      autoCheckedList: [], //預勾清單，只進行第一次預勾，後續清空該列表
      insurer_age: this.$store.getters.MfEditing.insurer.insured_age, //要保人年齡
      insurer_gender: this.$store.getters.MfEditing.insurer.insured_gender, //要保人性別
      insured_age: this.$store.getters.MfEditing.insured.insured_age, //被保人年齡
      insured_gender: this.$store.getters.MfEditing.insured.insured_gender, //被保人性別
    };
  },
  computed: {
    addOtherButtonShow() {
      if (this.$store.getters.MfEditing.inputType != "family") {
        return this.scProductListScope.some((item) => {
          return item.is_relationship == "1";
        });
      } else {
        return false;
      }
    },
    is_selected_sc() {
      return this.scProductListScope.some((item) => {
        return item.is_checked == "1";
      });
    },
    MfEditing() {
      return this.$store.getters.MfEditing;
    },
    filteredScList() {
      return (this.scProductListScope || []).filter(
        (item) => !(item.rmk && item.rmk.trim())
      );
    },
  },
  mounted() {
    this.autoCheckedList = _.cloneDeep(this.mainProduct.group_sc_list) || [];
  },
  methods: {
    init() {
      //初始化其他被保人清單該有誰
      let MfEditing = this.$store.getters.MfEditing;
      this.other_people_list = [];
      if (MfEditing.inputType == "family")
        this.other_people_list = this.$store.getters.MemberList.filter(
          (item) => {
            return item.insured_id != MfEditing.insured.insured_id;
          }
        );
      //無ID狀態下要被保不同人，需要把要保人也加入其他被保人
      if (
        MfEditing.inputType == "noId" &&
        MfEditing.insurer.insured_name != MfEditing.insured.insured_name
      ) {
        this.other_people_list.push(MfEditing.insurer);
      }
      this.scProductListScope = _.cloneDeep(this.mainProduct.sc_prod_list);
      this.getScList();
    },
    getScList() {
      let MfEditing = this.$store.getters.MfEditing;
      this.$mfAPI
        .MFB0_1000__querySCList({
          mc_prod_id: this.mainProduct.FEATURE_DATA.prod_id,
          rider_type: this.mainProduct.FEATURE_DATA.rider_type,
          other_insured_list: [
            ...this.other_people_list,
            ...this.other_insured_list,
          ],
          insured: MfEditing.insured,
          insurer: {
            ...MfEditing.insurer,
          },
          checked_sc_list: this.scProductListScope
            .filter((item) => {
              return item.is_checked == "1";
            })
            .map((sc) => {
              return {
                prod_idx: sc.prod_idx || "",
                mc_idx: sc.mc_idx || "",
                sc_idx: sc.sc_idx || "",
                prod_id: sc.prod_id,
                relationship: sc.relationship,
                insured_name: sc.insured_name,
                insured_id: sc.insured_id,
                insured_gender: sc.insured_gender,
                insured_birthday: sc.insured_birthday,
                insured_age: sc.insured_age,
                pay_prd: sc.pay_prd,
                amt: sc.amt,
                amt_unit: sc.amt_unit,
                job_cat: sc.job_cat,
                pay_dis: sc.pay_dis || "0",
                group_dis: sc.group_dis || "0",
                premium: sc.premium,
                amt_floor_format: sc.amt_floor_format,
                amt_formatVal: sc.amt_formatVal,
                job_select: sc.job_select,
                relationship: sc.relationship,
                cwp_level: sc.cwp_level,
                is_spillover4: sc.is_spillover4,
                level: this.mainProduct.level || "",
              };
            }),
          channel_type: this.$store.getters.UserChannelType,
          isDirectMarketingUser: this.$store.getters.IsDirectMarketingUser,
        })
        .then((res) => {
          this.loading = false;
          this.addOtherInsuredPopup = false;
          //登入者身分通路別卡控
          // res.prod_list = this.channelTypeFilter(res.prod_list);
          this.scProductListScope = res.prod_list.map((item) => {
            //短年期用的(注意順序)
            item.prod_pay_prd = item.prod_pay_prd || item.pay_prd;
            //附約預設欄
            item.amt_formatVal =
              item.amt_unit != "" ? this.$amtUnitFormat(item.amt_unit) : 1;
            item.amt_floor_format = item.amt_floor / item.amt_formatVal;
            item.amt_ceil_format = item.amt_ceil / item.amt_formatVal;
            item.sc_idx = item.sc_idx || "";
            item.amt = item.amt || "";
            item.premium = item.premium || "0";
            item.job_cat = item.job_cat || "";
            item.pay_prd = !item.pay_prd ? null : this.mainProduct.pay_prd;
            item.pay_dis = item.pay_dis || "0";
            item.group_dis = item.group_dis || "0";
            item.relationship =
              item.relationship ||
              (item.sc_relationship.indexOf("2") > -1 ||
              item.sc_relationship.indexOf("3") > -1
                ? ""
                : item.sc_relationship);
            item.job_select = [];
            for (let i = item.job_start; i <= item.job_end; i++) {
              item.job_select.push(i);
            }
            if (
              item.amt_unit == "7" ||
              (item.amt_unit == "8" && item.amt_list == "")
            ) {
              item.amt_select = [];
              for (
                let i = parseInt(item.amt_floor_format);
                i <= parseInt(item.amt_ceil_format);
                i++
              ) {
                item.amt_select.push(i.toString());
              }
            } else if (item.amt_list != "") {
              item.amt_select = item.amt_list.split(",");
            }
            //開始壓紅字(暫由前端)
            item.rmk =
              this.getProdvalid(
                item,
                item.insured_age,
                this.mainProduct.pay_prd,
                item.pol_period,
                "附約",
                this.$store.getters.MfEditing.insured.insured_birthday,
                "",
                this.$store.getters.MfEditing.insured.insured_gender
              ) + item.rmk;
            if (
              //配合主附約職業類別連動，防止主約職業類別範圍超過附約，檢核並顯示警示文字
              this.mainProduct.job_cat != "" &&
              item.job_select.length > 0 &&
              !item.job_select.some(
                (item) => parseInt(item) == this.mainProduct.job_cat
              )
            ) {
              item.rmk += `職業類別限${item.job_start}~${item.job_end}類。`;
            }

            //一年期豁免附約年齡判斷
            if (item.other_limit4 === "1") {
              let other_limit4_age2 = item.other_limit4_age2;
              if (
                other_limit4_age2 &&
                parseInt(this.mainProduct.pay_prd) +
                  parseInt(this.MfEditing.insurer.insured_age) >
                  parseInt(other_limit4_age2)
              ) {
                let rmk = `主約繳費期滿時，要保人不得超過${other_limit4_age2}歲。`;
                item.rmk != "" ? (item.rmk += "\n" + rmk) : (item.rmk = rmk);
              }
              let other_limit4_age1 = item.other_limit4_age1;
              if (
                other_limit4_age1 &&
                parseInt(this.mainProduct.pay_prd) +
                  parseInt(this.MfEditing.insured.insured_age) >
                  parseInt(other_limit4_age1)
              ) {
                let rmk = `主約繳費期滿時，被保人不得超過${other_limit4_age1}歲。`;
                item.rmk != "" ? (item.rmk += "\n" + rmk) : (item.rmk = rmk);
              }
            }

            //如果沒有紅字，則判斷是否該預勾，預勾完之後把預勾清單刪除
            if (
              item.rmk == "" &&
              this.autoCheckedList.find((sc) => sc.prod_id == item.prod_id)
            ) {
              item.is_checked = "1";
            }
            //顯示難字
            setTimeout(() => {
              this.registerHanlink();
            }, 100);
            Validator.extend(`checkAMT_${item.prod_id}`, {
              getMessage: "保額金額錯誤",
              validate: (value) => {
                let intValue = parseInt(value.split(",").join(""));
                let incr_unit = item.amt_incr_unit / item.amt_formatVal;
                return (
                  intValue >= item.amt_floor_format &&
                  intValue <= item.amt_ceil_format &&
                  (incr_unit == 0 ? true : intValue % incr_unit == 0)
                );
              },
            });
            Validator.extend(
              `checkRelationship_${item.prod_id}${item.insured_name}`,
              {
                getMessage: "請選擇承保身分",
                validate: (value) => {
                  if (value == "" && this.needCheckRequire) {
                    this.$mfNotice("您勾選的附約中有「承保身份」欄位未填寫。");
                    return false;
                  }

                  return true;
                },
              }
            );
            Validator.extend(`onlyMate_${item.prod_id}${item.insured_name}`, {
              getMessage: "配偶只能有一個",
              validate: (value) => {
                //目前找到的配偶
                let nowMateSet = new Set();
                this.scProductListScope.forEach((item) => {
                  if (item.relationship == "2") {
                    nowMateSet.add(
                      `${item.insured_name}${item.insured_age}${item.insured_birthday}${item.insured_gender}`
                    );
                  }
                });
                if (item.relationship == "2" && nowMateSet.size > 1) {
                  this.$mfNotice("配偶只能有一個");
                  return false;
                } else if (item.relationship == "3") {
                  if (nowMateSet.size < 2) {
                    this.$validator.reset();
                  }
                }

                return true;
              },
            });
            return item;
          });
          //清空自動勾選列表，因為只有第一次才要預勾
          this.autoCheckedList = [];
        });
    },
    async toImport() {
      // this.$emit("close");
      this.needCheckRequire = true;
      const checkResult = await this.$validator.validateAll();
      this.needCheckRequire = false;
      const { checkRiderExcludeMap } =
        await this.$mfAPI.MFA0_1000__checkRiderExclude({
          sc_prod_id_list: this.scProductListScope
            .filter((sc) => sc.is_checked == "1")
            .map((sc) => {
              return sc.prod_id;
            }),
          isSamePerson:
            this.MfEditing.sameInsurer ||
            this.MfEditing.insured.insured_id ==
              this.MfEditing.insurer.insured_id
              ? "1"
              : "0",
        });
      if (checkRiderExcludeMap.isAlert) {
        return this.$mfNotice(checkRiderExcludeMap.checkMsg);
      }
      if (checkResult) {
        //不可單獨附加某些特定豁免附約
        if (
          this.scProductListScope.filter((sc) => sc.is_checked == "1").length >
            0 &&
          this.scProductListScope.filter(
            (sc) => sc.free_prod != "2" && sc.is_checked == "1"
          ).length == 0
        ) {
          let sc = this.scProductListScope.filter(
            (sc) => sc.is_checked == "1"
          )[0];
          return this.$mfNotice(
            `主約不得單獨附加${sc.prod_name}(${sc.prod_id})`
          );
        }
        //檢查投保前提機制(2022/04/11新增)
        let needPreProdNotice = "";
        this.scProductListScope.forEach((nowSc) => {
          let needPrePordList = [];
          if (
            nowSc.is_checked == "1" &&
            nowSc.pre_con_ind == "1" &&
            nowSc.pre_prod_id
          ) {
            nowSc.pre_prod_id.split(",").forEach((preScId) => {
              let preScObj = this.scProductListScope.find(
                (sc) => sc.prod_id == preScId
              );
              if (preScObj && preScObj.is_checked != "1") {
                //需勾選該建議，但卻沒勾選
                needPrePordList.push(
                  `${preScObj.prod_name}(${preScObj.prod_id})`
                );
              } else {
                //因條件是"或"，因此如果其中之一有被勾選，則 needPrePordList 清空
                needPrePordList = [];
                return;
              }
            });
          }
          if (needPrePordList.length > 0) {
            needPreProdNotice += `
          欲選取${nowSc.prod_name}(${nowSc.prod_id})，應先選取`;
            needPrePordList.forEach((item) => {
              needPreProdNotice += needPrePordList.join("或");
            });
            needPreProdNotice += "。<br><br>";
          }
        });
        if (needPreProdNotice != "") {
          return this.$mfNotice(needPreProdNotice);
        }
        //豁免附約只能保一(2022/03/22新增)
        let freeList = this.scProductListScope.filter((item) => {
          return item.free_prod != "0" && item.is_checked == "1";
        });
        if (freeList.length > 1) {
          let freeNameList = freeList.map((item) => {
            return item.prod_name;
          });
          let errorMessage = "同一建議不可同時附加" + freeNameList.join("、");
          return this.$mfNotice(errorMessage);
        }
        //豁免附約只能保一(2022/03/22新增)

        //開始計算保費&匯入父組件
        for (let i = 0; i < this.scProductListScope.length; i++) {
          let item = this.scProductListScope[i];
          if (
            item.is_checked == "1" &&
            item.amt_ceil == item.amt_floor &&
            item.free_prod == "0"
          ) {
            item.amt = parseInt(item.amt_floor_format) + "";
            try {
              let res = await this.$mfAPI.MFC0_1000__getPremium({
                amt: parseInt(item.amt_floor_format) + "",
                prod_id: item.prod_id,
                insured_age: item.insured_age,
                insured_gender: item.insured_gender,
                pay_prd: item.pay_prd ? this.mainProduct.pay_prd : "1",
                pol_period: this.mainProduct.pol_period || "10",
                pay_freq: this.mainProduct.pay_freq,
                pay_dis: this.mainProduct.pay_dis,
                group_dis: this.mainProduct.group_dis,
                job_cat: item.job_cat,
                add_method: this.mainProduct.add_method,
              });
              item.premium = res.premium;
            } catch {
              item.premium = "0";
            }
          }
        }
        this.mainProduct.sc_prod_list = _.cloneDeep(this.scProductListScope);
        this.$emit("close");
        //顯示難字
        setTimeout(() => {
          this.registerHanlink();
        }, 100);
      } else {
        this.$mfNotice("您勾選的附約中有「承保身份」欄位未填寫。");
      }
    },
    clear(target, keyName) {
      target[keyName] = "";
      this.$forceUpdate();
    },
    addOne() {
      this.addOtherCeater.push({
        insured_name: "",
        insured_gender: "",
        insured_birthday: "",
        insured_age: "",
      });
    },
    deleteOne(index) {
      this.addOtherCeater.splice(index, 1);
    },
    async addOthersHandler() {
      const checkResult = await this.$validator.validateAll();
      let haveSomePeople = false;
      let MfEditing = this.$store.getters.MfEditing;
      this.addOtherCeater.forEach((newitem) => {
        [
          MfEditing.insured,
          ...this.other_people_list,
          ...this.addOtherCeater,
        ].forEach((oldItem) => {
          if (newitem == oldItem) return;
          if (
            newitem.insured_name == oldItem.insured_name &&
            newitem.insured_gender == oldItem.insured_gender &&
            newitem.insured_age == oldItem.insured_age &&
            newitem.insured_birthday == oldItem.insured_birthday
          ) {
            haveSomePeople = true;
          }
        });
      });
      if (haveSomePeople) {
        return this.$toast.info({
          title: `不可新增姓名、性別、年齡皆相同的其他被保人`,
        });
      }
      if (checkResult && !haveSomePeople) {
        this.other_insured_list = this.addOtherCeater.map((item) => {
          item.isAdded = true;
          return item;
        });
        this.loading = true;
        this.getScList();
      }
    },
    clearBirthday(target, index) {
      this.$refs[`${index}_dataPicker`][0].clearDate();
      setTimeout(() => {
        target.insured_birthday = "";
        target.insured_age = "";
        this.$refs[`${index}_dataPicker`][0].clearDate();
        this.$forceUpdate();
      });
    },
    checkHandler($event, item) {
      item.is_checked = $event.target.checked ? "1" : "0";
    },
  },
  watch: {
    open(val) {
      if (val) {
        this.insured_age = this.$store.getters.MfEditing.insured.insured_age;
        this.insured_gender =
          this.$store.getters.MfEditing.insured.insured_gender;
        this.insurer_age = this.$store.getters.MfEditing.insurer.insured_age;
        this.insurer_gender =
          this.$store.getters.MfEditing.insurer.insured_gender;
        this.addOtherInsuredPopup = false;
        this.loading = true;
        this.init();
        // this.scProductListScope = this.mainProduct.sc_prod_list.length
        //   ? _.cloneDeep(this.mainProduct.sc_prod_list)
        //   : _.cloneDeep(mcokScProductList.prod_list);

        // this.scProductListScope.forEach((item) => {
        //   item.relationship = item.relationship || "";
        // });
      }
    },
    addOtherInsuredPopup(val) {
      if (val) {
        this.addOtherCeater = [
          ...this.other_insured_list,
          {
            insured_id: "",
            insured_name: "",
            insured_gender: "",
            insured_birthday: "",
            insured_age: "",
          },
        ];
        //顯示難字
        setTimeout(() => {
          this.registerHanlink();
        }, 100);
      }
    },
  },
};
</script>

<style lang="scss">
.scProductPopup {
  &__notice {
    font-size: 13px;
    color: #de4054;
  }
  select.form-control.is-invalid {
    padding-right: 1rem !important;
    background-position: right 0.5rem center;
  }
  .sc__table {
    width: 100% !important;
    & > .mfTable__table__head > div {
      &:nth-of-type(1) {
        width: 10%;
        line-height: 40px;
        height: 40px;
      }
      //商品名稱
      &:nth-of-type(2) {
        width: 35%;
      }
      //被保險人
      &:nth-of-type(3) {
        width: 15%;
      }
      //承保身分
      &:nth-of-type(4) {
        width: 18%;
      }
      //不可承保提示
      &:nth-of-type(5) {
        width: 22%;
      }
    }
    & > .mfTable__table__body {
      max-height: calc(40px * 6);
      overflow-y: overlay;
    }
    & > .mfTable__table__body > .mfTable__table__body--row:nth-of-type(even) {
      background-color: #f5f5f5;
    }
    & > .mfTable__table__body > .mfTable__table__body--row {
      border-radius: 4px;
      border: solid 1px #c2c4c7;
    }
    & > .mfTable__table__body > .mfTable__table__body--row > div {
      &:nth-of-type(1) {
        width: 10%;
        height: 40px;
      }
      //商品名稱
      &:nth-of-type(2) {
        width: 35%;
      }
      //被保險人
      &:nth-of-type(3) {
        width: 15%;
      }
      //承保身分
      &:nth-of-type(4) {
        width: 18%;
        padding: 4px 16px !important;
      }
      //不可承保提示
      &:nth-of-type(5) {
        width: 22%;
        padding: 0 8px;
        span {
          display: inline-block;
          width: 100%;
          background-color: rgba(245, 136, 24, 0.15);
          color: #de4054;
          font-size: 14px;
        }
      }
    }
  }
  .addOther {
    &__item {
      padding: 10px 0;
      display: flex;
      height: 182px;
      border-radius: 4px;
      border: solid 1px #c2c4c7;
      background-color: rgba(245, 245, 245, 0.4);
      position: relative;
      &__index {
        width: 30px;
        height: 100%;
        border-right: 1px solid #c2c4c7;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      &__form {
        padding: 17px;
      }
      &__delete {
        position: absolute;
        top: 20px;
        right: 61px;
      }
    }
    &__row {
      display: flex;
      align-items: center;
      > span {
        margin-right: 8px;
      }
    }
    &__button {
      height: 60px;
      margin: 10px 0 0;
      border-radius: 4px;
      border: solid 1px #c2c4c7;
      background-color: rgba(245, 245, 245, 0.4);
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      color: #323a45;
      cursor: pointer;
      font-weight: 700;
      &__icon {
        font-size: 36px;
        color: #f58818;
      }
    }
  }
}
</style>
